
import { Verification } from '../Verification';
import { InterceptMiddle } from '../../regular';
/**
 * 判断试题是否已答
 * @param list 试题list
 * @param condition 完整的条件list
 * @return Boolean
 */
export const IsAnswered = (list, condition) => {
    // console.warn('1 :>> ', 1);
    // console.log('condition :>> ', condition);
    newCondition = InterceptMiddle(condition, ['['], [']'])?InterceptMiddle(condition, ['['], [']']).split(',') : [],
    newList = []
    // console.log('newCondition :>> ', newCondition);/
    newList = list.filter((info) => {
        return newCondition.indexOf(info.quesCode) != -1
    })
    newList = JSON.parse(JSON.stringify(newList))
    // console.log('object :>> ', object);
    // console.log(Verification(newList).result)
    return !Verification(newList).result;
}

